export default __webpack_public_path__ + "static/media/obj1.f0806a93.jpg";